import { render } from "./HeartRateAlertSettingList.vue?vue&type=template&id=4badff14&scoped=true&ts=true"
import script from "./HeartRateAlertSettingList.vue?vue&type=script&lang=ts"
export * from "./HeartRateAlertSettingList.vue?vue&type=script&lang=ts"

import "./HeartRateAlertSettingList.vue?vue&type=style&index=0&id=4badff14&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4badff14"]])

export default __exports__